module.exports = __webpack_public_path__ + "img/watermelon-slice.2ff20570.svg";